
import AppRepeatedTaskEdit from "./RepeatedTaskEdit.vue";
import Vue from "vue";
import { RepeatedTask } from "@/models/tasks/repeated-task";
import {TranslateResult} from "vue-i18n";
import {TaskService} from "@/services";

export default Vue.extend({
	data(){
		return {
			isSaving: false
		};
	},
	props: {
		value: {
			type: Object as ()=>RepeatedTask,
			required: true
		}
	},
	computed: {
		title():TranslateResult {
			if (this.value.ID == 0){
				return this.$ct("create-repeated-task");
			}
			return this.$ct("edit-repeated-task");
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (this.isSaving) return;
			try{
				if (this.value.ID == 0){
					var result = await TaskService.createdRepeatedTask(this.value);
				}else{
					var result = await TaskService.updateRepeatedTask(this.value);
				}
				this.$emit("input", result);
				this.close();
			}catch(err){
			}
			this.isSaving = false;
		}
	},
	components: {
		AppRepeatedTaskEdit
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
